import React, { useContext, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { FooterBaseStyle, MeasureLogStyle } from './MeasureLogStyle';
import { AppContext } from '../../../App';
type MeasureLogFooterProps = {
  buttonEnable: boolean;
  onClickDispImageFile: () => void;
};

const MeasureLogFooter: React.FC<MeasureLogFooterProps> = (props) => {
  const { t } = useTranslation();
  const footerBaseStyle = FooterBaseStyle();
  const { login } = useContext(AppContext);

  //3次元ボタン有効フラグ
  const threeDButtonEnabled: boolean = login.GetSystemSettingModel.ThreeDButtonEnabled === 1 ? true : false;

  return (
    <>
      {threeDButtonEnabled ? (
        <Grid item xs={2}>
          <Button
            variant="contained"
            className={footerBaseStyle.buttonStyle}
            color="primary"
            disabled={!props.buttonEnable}
            disableElevation
            onClick={(e) => props.onClickDispImageFile()}
          >
            {t('MeasureLogFooter.三次元グラフ', '三次元グラフ')}
          </Button>
        </Grid>
      ) : null}
    </>
  );
};

export default MeasureLogFooter;
